import { useComputed } from "@homebound/beam";
import { ListFieldState, ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./aiFieldProposalForm";

/**
 * The AI proposal for `fieldName`, if the agent proposed one.
 */
export function useAiFieldProposal(
  fieldProposals: ListFieldState<AiFieldProposalFormValue> | undefined,
  fieldName: string,
): ObjectState<AiFieldProposalFormValue> | undefined {
  return useComputed(
    () => fieldProposals?.rows.find((p) => p.fieldName.value === fieldName),
    [fieldProposals, fieldName],
  );
}
